import { UserProfileType } from 'models/User';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export const useIsAuthenticated = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(null)

    const user: any = useSelector((state: RootState) => state.user)
    const now = moment().valueOf();

    useEffect(() => {
        if (user.IS_LOGGED_IN && user.EXPIRES_ON > now / 1000) {
            setIsAuthenticated(true)
        } else {
            setIsAuthenticated(false)
        }
    }, [user.IS_LOGGED_IN])


    return isAuthenticated;
}

export const useGetProfile = (): UserProfileType | null | undefined => {
    const user: any = useSelector((state: RootState) => state.user)
    return user.PROFILE
}